import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers'
import './index.css'
import Routes from './routes'
import { MOBILE } from './constants'

const middleware = [thunk]
const store = createStore(rootReducer, applyMiddleware(...middleware));

// @NOTE: browser sniffing hack for iOS fixes - e.g. issue #180
MOBILE && document.querySelector('html').classList.add('is-mobile')

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js